import { useEffect, useRef, useState } from 'react';
import { Search } from 'lucide-react';
import { useDebounce } from '../../hooks/useDebounce';

const SearchInput = ({ value = '', onChange, placeholder = 'Search', className = '' }) => {
  const [text, setText] = useState(value);
  const debounced = useDebounce(text, 300);

  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  const emitted = useRef(value);

  useEffect(() => {
    if (debounced === emitted.current) return;
    emitted.current = debounced;
    onChangeRef.current(debounced);
  }, [debounced]);

  return (
    <div className={`relative ${className}`}>
      <Search
        className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor"
        aria-hidden="true"
      />
      <input
        type="search"
        className="form-control !pl-9"
        value={text}
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={(event) => setText(event.target.value)}
      />
    </div>
  );
};

export default SearchInput;
